import { DispatchLoading, DispatchType, ResponseValid } from 'domain/utils/ReactUtils'
import { AuthService } from '../../../services/auth/authService';
import { StateType } from 'domain/types/base/base';
import { _UserData } from 'base/src/infra/storage/localStorage';
import { UsuarioResponse } from 'domain/types/usuario/usuarioResponse';
import { LOGIN_TOKEN } from 'domain/types/authentication/authentication';
import { AppThunk } from 'base/src/utils/reducerUtil';

const _AuthService = new AuthService();

export function Login(request: FormData, callBack: () => void): AppThunk {
    return async (dispatch) => {
        dispatch(DispatchLoading(LOGIN_TOKEN, DispatchType.LOADING, "Aguarde!", StateType.Master));

        const asyncResponse = await _AuthService.Login(request);
        if (ResponseValid(asyncResponse)) {
            const Usuario = asyncResponse as UsuarioResponse;
            _UserData.Register(Usuario);

            dispatch({
                payload: true,
                type: LOGIN_TOKEN
            });

        } else {
            _UserData.Clear();

            dispatch({
                payload: false,
                type: LOGIN_TOKEN
            });

            dispatch(DispatchLoading(LOGIN_TOKEN, DispatchType.ERROR, "Erro no Login!", StateType.Master, () => callBack));
        }
    };
}





